import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextAlignmentJustify32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconTextAlignmentJustify32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 10a1 1 0 0 1 0-2h21a1 1 0 1 1 0 2zm0 10a1 1 0 1 1 0-2h21a1 1 0 1 1 0 2zm-1-6a1 1 0 0 0 1 1h21a1 1 0 1 0 0-2H6a1 1 0 0 0-1 1m1 11a1 1 0 1 1 0-2h21a1 1 0 1 1 0 2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextAlignmentJustify32);
